<div id="maincontent">
		<div id="content" class="container_margin">
			<form action=""  name="tesslogin" id="tesslogin" ngSubmit="login()">
				<table id="login_form" aria-describedby="table">
					<!-- Logo -Start-->
					<th></th>

					<tbody><tr class="logo_container">
						<td><img src="assets/images/Toyota_Corp_Red.png" alt="Toyota"></td>
					</tr>
					<!-- Logo -End-->
	
					<tr>
						<td style="text-align: left;"><label class="bold" for="User ID">WorkdayID</label></td>
					</tr>
					<tr>
						<td style="text-align: left;"><input (keypress)="numberOnly($event)" class="input_box" name="username" type="text" id="userId" size="20" autofocus="" [(ngModel)]="userId"></td>
					</tr>
					<tr>
						<td style="text-align: left;"><label class="bold" for="Password">Password</label></td>
					</tr>
					<tr>
						<td style="text-align: left;"><input class="input_box" name="password" type="password" id="passwordId" size="20" [(ngModel)]="passwordId"></td>
					</tr>
					<tr>
						<td><span class="{{activeClass}}">Invalid username or password</span></td>
					</tr>				
					<!-- <tr>
						<td><br>
							<p class="disclaimer">By logging into this portal, I
								understand that I will be accessing confidential and proprietary
								information of Toyota and I agreed to use this information for
								only legitimate business purposes. I further understand that
								misuse of any information contained in this portal may result in
								my access being suspended or terminated by Toyota.</p> <br></td>
					</tr> -->
					<tr>
						<td>
							<!-- XSS Vulnerability Fix: HTML Encoding the attribute request_id-->
							 <input type="image" src="assets/images/Login-Button.png" alt="Angular Logo" id="Submit" (click)="login()">
						</td>
					</tr>
	
					<!--New code ends-->
				</tbody></table>
			</form>
		</div>
	</div>
  
